import { I18n } from "@aws-amplify/core";

import { fetchGet } from "../api/fetch";

export const getNoteType = async () => {
  let options = [];
  const typeIdName = {
    1: "General",
    2: "CompareResults",
    3: "InspectionSafety"
  }

  try {
    let noteType = await fetchGet(`note_types`);
    noteType.map((value) => {
      if (value.active) {
        options.push({
          id: value.id,
          name: I18n.get(`site_${typeIdName[value.id]}`),
        });
      }
      return
    });

  } catch (e) {
    console.log(e);
  }

  return options;
};
